import Navbar from "./Navbar";
import Footer from "./Footer";
import './Layout.styles.scss';

interface Props {
  children: React.ReactNode;
}

export function PrivateLayout({ children }: Props) {

  return (
    <>
        <Navbar />
         
        { children }
       
        <Footer />
    </>
  );
}
